import permissions from "../../data/permissions"

function load(component) {
    return () => import(`../../views/warehouse/transfer/${component}.vue`)
}


export default [
    {
        name: "TransferIssueVoucherCreate",
        path: "stock-transfer-voucher",
        component: () => import("../../views/warehouse/transfer/TransferIssueVoucherCreateView.vue"),
        meta: { requiresAuth: true, authorization: permissions.stock_transfer.create }
    },
    {
        name: "TransferIssueVoucherDisplay",
        path: "stock-transfer-voucher/:id",
        component: () => import("../../views/warehouse/transfer/TransferIssueVoucherDisplayView.vue"),
        meta: { requiresAuth: true, authorization: permissions.stock_transfer.read }
    },
    {
        name: "TransferIssueVoucherEdit",
        path: "stock-transfer-voucher/:id/edit",
        component: () => import("../../views/warehouse/transfer/TransferIssueVoucherEditView.vue"),
        meta: { requiresAuth: true, authorization: permissions.stock_transfer.update }
    },
    {
        name: "TransferIssueVoucherList",
        path: "stock-transfer-vouchers",
        component: () => import("../../views/warehouse/transfer/TransferIssueVoucherListView.vue"),
        meta: { requiresAuth: true, authorization: permissions.stock_transfer.index }
    },
    {
        name: "TransferReceiptVoucherCreate",
        path: "stock-transfer-receipt",
        component: load("TransferReceiptVoucherCreateView"),
        meta: { requiresAuth: true, authorization: permissions.stock_transfer_receipt.create }
    },
    {
        name: "TransferReceiptVoucherList",
        path: "stock-transfer-receipts",
        component: load("TransferReceiptVoucherListView"),
        meta: { requiresAuth: true, authorization: permissions.stock_transfer_receipt.index }
    },
    {
        name: "TransferReceiptVoucherDisplay",
        path: "stock-transfer-receipt/:id",
        component: load("TransferReceiptVoucherDisplayView"),
        meta: { requiresAuth: true, authorization: permissions.stock_transfer_receipt.read }
    },
    {
        name: "TransferReceiptVoucherEdit",
        path: "stock-transfer-receipt/:id/edit",
        component: load("TransferReceiptVoucherEditView"),
        meta: { requiresAuth: true, authorization: permissions.stock_transfer_receipt.update }
    },
    {
        name: "TransferIncomingVoucherList",
        path: "stock-incoming-transfers",
        component: load("TransferIncomingVoucherListView"),
        meta: { requiresAuth: true, authorization: permissions.stock_transfer.index }
    },
]